export function isNumeric(value) {
    return /^-?\d+$/.test(value);
}
//# sourceMappingURL=index.js.map